import { i18n } from 'locales'

export const CALENDLY_MARKETING_BASE_PATH = 'https://calendly.com/'

const TRANSLATED_LOCALES = ['fr', 'es', 'de', 'pt']

const getCalendlyMarketingLocaleSuffix = () => (
  TRANSLATED_LOCALES.includes(i18n.locale) ? i18n.locale : ''
)

export const buildCalendlyMarketingHref = (basePath, { query } = {}) => {
  const href = `${basePath}${getCalendlyMarketingLocaleSuffix()}`

  return query ? `${href}?${query}` : href
}
